import { useMemo } from "react";

import { DamageCostEvaluationDto, DamageDetectionDto } from "@/core/api/generated/v1";

import DamageCostEvaluationCreateUpdateModal, {
  DamageCostEvaluationCreateUpdateModalProps,
} from "../DamageCostEvaluation/DamageCostEvaluationCreateUpdateModal";

interface Props extends Omit<DamageCostEvaluationCreateUpdateModalProps, "createUpdateProps"> {
  createUpdateProps?: Partial<DamageCostEvaluationCreateUpdateModalProps["createUpdateProps"]>;
  damageDetection: DamageDetectionDto;
  onSave: (newValue: DamageCostEvaluationDto) => void;
}

export function DamageDetectionCreateLocalDamageCostEvaluationModal({
  damageDetection,
  onSave,
  ...otherProps
}: Props) {
  const vehicleDamageIds = useMemo(
    () => damageDetection.items?.map((x) => x.damage?.id || "")?.filter(Boolean),
    [damageDetection.items],
  );

  return (
    <DamageCostEvaluationCreateUpdateModal
      {...otherProps}
      createUpdateProps={{
        ...otherProps.createUpdateProps,
        defaultValues: {
          vehicleId: damageDetection.vehicle?.id,
          contractId: damageDetection.contract?.id,
          damageDetectionId: damageDetection.id,
          vehicleDamageIds: vehicleDamageIds,
          externalNumber: damageDetection.externalNumber,
          notes: damageDetection.notes,
          attachments: damageDetection.attachments,
          ...otherProps.createUpdateProps?.defaultValues,
        },
        defaultFormPerms: {
          canEditVehicle: false,
          ...otherProps.createUpdateProps?.defaultFormPerms,
        },
        formSettings: {
          vehicleDamageIdsSuggested: vehicleDamageIds,
        },
        onSave: (newValue) => {
          onSave(newValue);
          otherProps.createUpdateProps?.onSave && otherProps.createUpdateProps.onSave(newValue);
        },
      }}
    />
  );
}
